export const TITLE = "TITLE";
export const PIN_STATUS = "PIN_STATUS";
export const COLOR = "COLOR";
export const TAGS = "TAGS";
export const PRIORITY = "PRIORITY";
export const NOTE = "NOTE";
export const CLEAR_EDITOR = "CLEAR_EDITOR";
